module.exports = __webpack_public_path__ + "static/img/banner-2.bb03847f.png";